// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3hXGl","insightsList":"newBusinessInsightsMenu_insightsList__3uyGx","active":"newBusinessInsightsMenu_active__2ttX7"};